import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWhatAreTheMainWaysToPayForLongTermCarePage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-what-are-the-main-ways-to-pay-for-long-term-care/']} />;
}
